(() => {
  const popupSelector = 'popup-component[data-material-care-popup]';
  const openDialogSelector = 'dialog[open]:not([inert])';
  const closeButtonSelector = '[data-popup-close]';

  function closeOpenMaterialCareDrawer() {
    const popup = document.querySelector(`${popupSelector} ${openDialogSelector}`)?.closest(popupSelector);

    if (!popup) {
      return;
    }

    const closeButton = popup.querySelector(closeButtonSelector);

    if (closeButton) {
      closeButton.click();
      return;
    }

    const dialog = popup.querySelector('dialog[open]');

    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  }

  document.addEventListener('theme:product:added', closeOpenMaterialCareDrawer);
})();
